export default __webpack_public_path__ + "static/media/team6.1c884e51.jpg";